"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SkypeNotificationOption_1 = require("./SkypeNotificationOption");
exports.SkypeNotificationOption = SkypeNotificationOption_1.default;
var SkypeNotificationType_1 = require("./data/store/schema/SkypeNotificationType");
exports.SkypeNotificationType = SkypeNotificationType_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-skype-option/lib/index.js
// module id = 3371
// module chunks = 2 39